import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Suitcase = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <g
      stroke={props.color || theme.palette.grey600}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 7v16M18 7v16M21 23H3a2 2 0 01-2-2V9a2 2 0 012-2h18a2 2 0 012 2v12a2 2 0 01-2 2zM7 7V3a2 2 0 012-2h6a2 2 0 012 2v4" />
    </g>
  </svg>
);
